module.exports = __webpack_public_path__ + "2be3f228c0380d8c5872a2f151f37e9f.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/image/ic_logout_white.svg
// module id = 1164
// module chunks = 0